export const LOAD_ASSET_HIERARCHY_LEVELS_SUCCESS = "LOAD_ASSET_HIERARCHY_LEVELS_SUCCESS";
export const SET_ASSET_HIERARCHY_LEVELS = "SET_ASSET_HIERARCHY_LEVELS";
export const LOAD_ASSET_HIERARCHY_INITIATED = "LOAD_ASSET_HIERARCHY_INITIATED";

export const LOAD_ASSET_TYPES_SUCCEEDED = "LOAD_ASSET_TYPES_SUCCEEDED";
export const LOAD_ASSET_DEFAULTS_SUCCEEDED = "LOAD_ASSET_DEFAULTS_SUCCEEDED";

export const LOAD_ASSET_HIERARCHY_PROPERTIES_STARTED = "LOAD_ASSET_HIERARCHY_PROPERTIES_STARTED";
export const LOAD_ASSET_HIERARCHY_PROPERTIES_SUCCEEDED = "LOAD_ASSET_HIERARCHY_PROPERTIES_SUCCEEDED";
